import { getFulfillmentTypeTranslationKey } from "@msuite/utils/organizations";
import { guardString } from "@msuite/utils/strings";
import type { Enums, Nullable } from "@msuite/utils/types";
import { getFulfillmentTypeIcon, Icon } from "../icons";
import { localized } from "../localization";
import { cn } from "../utils";

/** Props Interface */
interface ServiceFulfillmentTypeTagProps {
	fulfillmentType: Nullable<Enums<"serviceFulfillmentType">>;
}

export function ServiceFulfillmentTypeTag({ fulfillmentType }: ServiceFulfillmentTypeTagProps) {
	if (!fulfillmentType) return guardString(null);

	/** Render */
	return (
		<div className="h-stack">
			<Icon
				name={getFulfillmentTypeIcon(fulfillmentType)}
				className={cn(
					fulfillmentType === "internal"
						? "stroke-emerald-500 fill-emerald-500/20"
						: "stroke-orange-500 fill-orange-500/20",
				)}
			/>
			<p>{localized(getFulfillmentTypeTranslationKey(fulfillmentType))}</p>
		</div>
	);
}
